import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import { media } from "utils/style";

const StyledLinkSmall = ({ to, background, disabled, children, replace, linkType, href, target, ...props }) => {
  if (linkType === "anchor") {
    return (
      <A {...props} href={href} target={target ? target : null} background={background}>
        {children}
      </A>
    );
  }
  return (
    <Link {...props} to={to} replace={replace ? true : false} background={background}>
      {children}
    </Link>
  );
};

export default StyledLinkSmall;

StyledLinkSmall.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  linkType: PropTypes.string,
  href: PropTypes.string,
  background: PropTypes.string,
  disabled: PropTypes.bool,
  replace: PropTypes.bool,
  disabledStatus: PropTypes.string,
  children: PropTypes.node.isRequired
};

const style = css`

  font-size: 12px;
  border-radius: 15px;
  border-width: 100px;
  /*border-radius: 0.9rem;
  border-width: 6.0rem;*/
  width: 78px;  
  line-height: 16px;
  text-align: center;
  border: 1pt solid red;
  padding: 5px;


  /*border-radius: 8.25rem;
  border-width: 0.0325rem;*/
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-style: normal;
  font-weight: bold;
  /*line-height: 1;*/
  /*margin: 0 12px 0 0;*/
  max-width: 80px;
  /*padding: 1em calc(1em * 3.14);*/
  position: relative;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  touch-action: manipulation;
  -webkit-transition-duration: 0.15s;
  transition-duration: 0.15s;
  -webkit-transition-property: color;
  transition-property: color;
  vertical-align: middle;
  /*width: auto;*/
  background: ${props => (props.background === "white_background" ? "#FFF" : "#000")};
  color: ${props => (props.background === "white_background" ? "#000" : "#FFF")};
  border: ${props => (props.background === "white_background" ? "1px solid" : "none")};

  ${props => {
    if (props) {
      if (props.disabledStatus === "disabled") {
        return {
          pointerEvents: "none",
          opacity: ".4"
        };
      }
    }
  }};
  
  ${media.mobile`
    /*width: 100% !important;*/
    margin-bottom: 5px !important;
    border-radius:15px;
    font-size:10px;
    
  `}
`;

const A = styled.a`
  ${style}
`;

const Link = styled(RouterLink)`
  ${style}
`;
